module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "70%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("1")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline2",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Rio de Janeiro, Brazil")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("R")])])])]), _vm._v("oger Leiland both hated and loved Brazil. On one hand, he’d grown up there professionally. The Trust, the organization he worked for, the one he was now in charge of, had planted him in Rio many years ago. He’d lived there under his alias, Paul Costa, posing as an American businessman selling vaccinations to the Brazilian government. Paul Costa had fallen in love with a woman named Marta and consequently had fallen in love with Brazil itself. But then Marta was gone, dead after a drive-by shooting on the Rodovia dos Lagos Highway. The shooting had left Paul Costa all but dead, too. The Trust had realized he was slipping and pulled him out. Sent him to Chicago, where he was like a walking corpse slowly coming back to life, strangely paralleling his research there—the Juliet Project. Eventually, he’d moved to New York where he took solace in the resilience of power instead of the tenuous comforts of love. He climbed the ladder at the Trust until he’d forged an entirely new existence at the top, all the while keeping his thumb squarely on the Juliet Project.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now, his expertise was needed in Rio again. Technically, he could have sent someone else, but he wanted to prove to himself that he was at the apex of his game, that Rio no longer touched him. He had been back in Brazil for a few weeks, and while he had felt a flicker of longing for his old life, it was only that—a flicker. He was a different person now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had done his job while here. He’d gotten all the intel he required, and now he was meeting with Elena Mistow. Usually members of the Trust knew each other only by their aliases, and they’d been strictly trained to look no further. But even before he was a board member of the Trust, he knew Elena Mistow’s real name. Everyone did. Because Elena Mistow was royalty. Her father had founded the entire organization.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now, he and the woman called Elena sat at an outdoor café in Santa Terese, a charming area set on a hillside in Old Rio. He tried not to be impressed by Elena. She was younger than he, after all, and his subordinate. But there was her lineage. And her beauty.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Elena was all business. “What do we know about Luiz Gustavo de Jardim? Will he show himself anytime soon?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gustavo will appear in public in the next six months. He has to. He’s talking about running for office again, and he needs to thwart rumors that he’s already dead.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Wouldn’t that be convenient?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They both laughed. Nothing was ever easy or convenient with the Trust. They were silent for a minute, sipping coffee that tasted nutty and somewhat ashy. To the many on the street, they probably looked like a couple enjoying a break from the day.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He’ll pull the same stunt he always does,” Roger continued. “He’ll make his kids and wife surround him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The bastard uses them as human shields,” Elena said bitterly, which amazed Roger. She still cared about who got hurt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It works for him,” Roger said. “He’s a small man. His wife is the same height. By now one of his sons will probably be taller.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Audacious,” she murmured. “And evil.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We might have to take out the shields.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They exchanged a long look.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Roger broke the stare first, taking another sip of his coffee and gazing at passersby.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We’ve never done that,” Elena said. “We’ve sworn not to.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s impossible to infiltrate Gustavo’s inner circle…so other measures have to be taken to eliminate him. And times are changing. You know that as well as I.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No collateral damage. That’s always been our rule.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Everything changes. Don’t hold on too tight. Just hold on to our mission. Taking out Gustavo, no matter what the cost, advances our end, and that’s still pure.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Elena Mistow peered up at the gray-blue sky. She seemed to study something in the atmosphere. A minute passed, then another. “Jesus,” Elena said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Roger stayed silent. He sensed the searching of her mind, the processing, the emotion. He hoped she would draw the conclusion he’d already made.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Finally, she nodded. “So we take out the shields as a last resort.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Roger permitted himself the faintest of smiles before he raised his cup and took another sip.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52086551","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodliarthe_ch01.vue
// module id = 69
// module chunks = 0